import React, { useState, useEffect } from 'react';
import { X, Search as SearchIcon } from 'lucide-react';
import { season2526, season2425, podcasts } from '../data/mock';

const SearchModal = ({ isOpen, onClose }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (query.length > 1) {
      const allItems = [
        ...season2526.map(item => ({ ...item, category: 'Season 25/26' })),
        ...season2425.map(item => ({ ...item, category: 'Season 24/25' })),
        ...podcasts.map(item => ({ ...item, category: 'Podcasts' }))
      ];
      
      const filtered = allItems.filter(item => 
        item.title.toLowerCase().includes(query.toLowerCase()) ||
        (item.composer && item.composer.toLowerCase().includes(query.toLowerCase())) ||
        (item.artists && item.artists.toLowerCase().includes(query.toLowerCase()))
      );
      
      setResults(filtered.slice(0, 8));
    } else {
      setResults([]);
    }
  }, [query]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-start justify-center pt-20">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/90 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Search Container */}
      <div className="relative w-full max-w-2xl mx-4">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute -top-12 right-0 w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white/60 hover:text-white hover:bg-white/20 transition-all"
        >
          <X className="w-5 h-5" />
        </button>

        {/* Search Input */}
        <div className="relative">
          <SearchIcon className="absolute left-5 top-1/2 -translate-y-1/2 w-6 h-6 text-white/40" />
          <input
            type="text"
            placeholder="Search anything"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            autoFocus
            className="w-full pl-14 pr-6 py-5 bg-[#1a1a1a] border border-white/10 rounded-xl text-white text-lg placeholder:text-white/40 focus:outline-none focus:border-[#e4002b] transition-colors"
          />
        </div>

        {/* Results */}
        {results.length > 0 && (
          <div className="mt-4 bg-[#1a1a1a] border border-white/10 rounded-xl overflow-hidden">
            {results.map((item, index) => (
              <div
                key={`${item.category}-${item.id}-${index}`}
                className="flex items-center gap-4 p-4 hover:bg-white/5 cursor-pointer transition-colors border-b border-white/5 last:border-0"
              >
                {item.image && (
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-16 h-16 rounded-lg object-cover"
                  />
                )}
                <div className="flex-1 min-w-0">
                  <p className="text-[#e4002b] text-xs font-medium mb-1">{item.category}</p>
                  <h3 className="text-white font-medium truncate">{item.title}</h3>
                  {item.composer && (
                    <p className="text-white/60 text-sm truncate">{item.composer}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {query.length > 1 && results.length === 0 && (
          <div className="mt-4 bg-[#1a1a1a] border border-white/10 rounded-xl p-8 text-center">
            <p className="text-white/60">No results found for "{query}"</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchModal;
